/**
 * Icons.jsx
 * Created by michaelbray on 7/9/17.
 */

import BaseIcon from './BaseIcon';

export class IconWarning extends BaseIcon {}
IconWarning.defaultProps = {
    iconName: 'rec-icon-warning',
    iconClass: 'rec-icon-warning',
    alt: 'Warning'
};

export class IconInfo extends BaseIcon {}
IconInfo.defaultProps = {
    iconName: 'rec-icon-info',
    iconClass: 'rec-icon-info',
    alt: 'Info'
};

export class IconError extends BaseIcon {}
IconError.defaultProps = {
    iconName: 'rec-icon-error',
    iconClass: 'rec-icon-error',
    alt: 'Error'
};

export class IconCheckCircle extends BaseIcon {}
IconCheckCircle.defaultProps = {
    iconName: 'rec-icon-check-circle',
    iconClass: 'rec-icon-check-circle',
    alt: 'Check'
};

export class IconClose extends BaseIcon {}
IconClose.defaultProps = {
    iconName: 'rec-icon-close',
    iconClass: 'rec-icon-close',
    alt: 'Close'
};

export class IconPerson extends BaseIcon {}
IconPerson.defaultProps = {
    iconName: 'rec-icon-person',
    iconClass: 'rec-icon-person',
    alt: 'Person'
};

export class IconCart extends BaseIcon {}
IconCart.defaultProps = {
    iconName: 'rec-icon-cart',
    iconClass: 'rec-icon-cart',
    alt: 'Cart'
};

export class IconCog extends BaseIcon {}
IconCog.defaultProps = {
    iconName: 'rec-icon-cog',
    iconClass: 'rec-icon-cog',
    alt: 'Cog'
};

export class IconSearch extends BaseIcon {}
IconSearch.defaultProps = {
    iconName: 'rec-icon-search',
    iconClass: 'rec-icon-search',
    alt: 'Search'
};

export class IconCloseCircle extends BaseIcon {}
IconCloseCircle.defaultProps = {
    iconName: 'rec-icon-close-circle',
    iconClass: 'rec-icon-close-circle',
    alt: 'Close'
};

export class IconCalendar extends BaseIcon {}
IconCalendar.defaultProps = {
    iconName: 'rec-icon-calendar',
    iconClass: 'rec-icon-calendar',
    alt: 'Calendar'
};

export class IconArrowUp extends BaseIcon {}
IconArrowUp.defaultProps = {
    iconName: 'rec-icon-arrow-up',
    iconClass: 'rec-icon-arrow-up',
    alt: 'Up'
};

export class IconArrowDown extends BaseIcon {}
IconArrowDown.defaultProps = {
    iconName: 'rec-icon-arrow-down',
    iconClass: 'rec-icon-arrow-down',
    alt: 'Down'
};

export class IconChevronLeft extends BaseIcon {}
IconChevronLeft.defaultProps = {
    iconName: 'rec-icon-chevron-left',
    iconClass: 'rec-icon-chevron-left',
    alt: 'Left'
};

export class IconChevronRight extends BaseIcon {}
IconChevronRight.defaultProps = {
    iconName: 'rec-icon-chevron-right',
    iconClass: 'rec-icon-chevron-right',
    alt: 'Right'
};

export class IconChevronUp extends BaseIcon {}
IconChevronUp.defaultProps = {
    iconName: 'rec-icon-chevron-up',
    iconClass: 'rec-icon-chevron-up',
    alt: 'Up'
};

export class IconChevronDown extends BaseIcon {}
IconChevronDown.defaultProps = {
    iconName: 'rec-icon-chevron-down',
    iconClass: 'rec-icon-chevron-down',
    alt: 'Down'
};

export class IconAddCircle extends BaseIcon {}
IconAddCircle.defaultProps = {
    iconName: 'rec-icon-add-circle',
    iconClass: 'rec-icon-add-circle',
    alt: 'Add Circle'
};

export class IconPeople extends BaseIcon {}
IconPeople.defaultProps = {
    iconName: 'rec-icon-people',
    iconClass: 'rec-icon-people',
    alt: 'People'
};

export class IconAccessibility extends BaseIcon {}
IconAccessibility.defaultProps = {
    iconName: 'rec-icon-accessibility',
    iconClass: 'rec-icon-accessibility',
    alt: 'Accessibility'
};

export class IconAccountBox extends BaseIcon {}
IconAccountBox.defaultProps = {
    iconName: 'rec-icon-account-box',
    iconClass: 'rec-icon-account-box',
    alt: 'Account Box'
};

export class IconSupervisorAccount extends BaseIcon {}
IconSupervisorAccount.defaultProps = {
    iconName: 'rec-icon-supervisor-account',
    iconClass: 'rec-icon-supervisor-account',
    alt: 'Supervisor Account'
};

export class IconAccountCircle extends BaseIcon {}
IconAccountCircle.defaultProps = {
    iconName: 'rec-icon-account-circle',
    iconClass: 'rec-icon-account-circle',
    alt: 'Account Circle'
};

export class IconCalendarAvailable extends BaseIcon {}
IconCalendarAvailable.defaultProps = {
    iconName: 'rec-icon-calendar-available',
    iconClass: 'rec-icon-calendar-available',
    alt: 'Calendar Available'
};

export class IconCalendarBusy extends BaseIcon {}
IconCalendarBusy.defaultProps = {
    iconName: 'rec-icon-calendar-busy',
    iconClass: 'rec-icon-calendar-busy',
    alt: 'Calendar Busy'
};

export class IconCalendarNote extends BaseIcon {}
IconCalendarNote.defaultProps = {
    iconName: 'rec-icon-calendar-note',
    iconClass: 'rec-icon-calendar-note',
    alt: 'Calendar Note'
};

export class IconClock extends BaseIcon {}
IconClock.defaultProps = {
    iconName: 'rec-icon-clock',
    iconClass: 'rec-icon-clock',
    alt: 'Clock'
};

export class IconGroupAdd extends BaseIcon {}
IconGroupAdd.defaultProps = {
    iconName: 'rec-icon-group-add',
    iconClass: 'rec-icon-group-add',
    alt: 'Adding a Group'
};

export class IconHome extends BaseIcon {}
IconHome.defaultProps = {
    iconName: 'rec-icon-home',
    iconClass: 'rec-icon-home',
    alt: 'Home'
};

export class IconMood extends BaseIcon {}
IconMood.defaultProps = {
    iconName: 'rec-icon-mood',
    iconClass: 'rec-icon-mood',
    alt: 'Mood'
};

export class IconPeopleOutline extends BaseIcon {}
IconPeopleOutline.defaultProps = {
    iconName: 'rec-icon-people-outline',
    iconClass: 'rec-icon-people-outline',
    alt: 'People'
};

export class IconPersonAdd extends BaseIcon {}
IconPersonAdd.defaultProps = {
    iconName: 'rec-icon-person-add',
    iconClass: 'rec-icon-person-add',
    alt: 'Adding a Person'
};

export class IconPersonOutline extends BaseIcon {}
IconPersonOutline.defaultProps = {
    iconName: 'rec-icon-person-outline',
    iconClass: 'rec-icon-person-outline',
    alt: 'Person'
};

export class IconPortrait extends BaseIcon {}
IconPortrait.defaultProps = {
    iconName: 'rec-icon-portrait',
    iconClass: 'rec-icon-portrait',
    alt: 'Portrait'
};

export class IconCogBox extends BaseIcon {}
IconCogBox.defaultProps = {
    iconName: 'rec-icon-cog-box',
    iconClass: 'rec-icon-cog-box',
    alt: 'Cog Inside a Box'
};

export class IconAddBox extends BaseIcon {}
IconAddBox.defaultProps = {
    iconName: 'rec-icon-add-box',
    iconClass: 'rec-icon-add-box',
    alt: 'Add Box'
};

export class IconAddCircleOutline extends BaseIcon {}
IconAddCircleOutline.defaultProps = {
    iconName: 'rec-icon-add-circle-outline',
    iconClass: 'rec-icon-add-circle-outline',
    alt: 'Add'
};

export class IconAdd extends BaseIcon {}
IconAdd.defaultProps = {
    iconName: 'rec-icon-add',
    iconClass: 'rec-icon-add',
    alt: 'Add'
};

export class IconArrowCorner extends BaseIcon {}
IconArrowCorner.defaultProps = {
    iconName: 'rec-icon-arrow-corner',
    iconClass: 'rec-icon-arrow-corner',
    alt: 'Arrow Pointing to the Right Corner'
};

export class IconArrowBack extends BaseIcon {}
IconArrowBack.defaultProps = {
    iconName: 'rec-icon-arrow-back',
    iconClass: 'rec-icon-arrow-back',
    alt: 'Back'
};

export class IconArrowForward extends BaseIcon {}
IconArrowForward.defaultProps = {
    iconName: 'rec-icon-arrow-forward',
    iconClass: 'rec-icon-arrow-forward',
    alt: 'Next'
};

export class IconArrowTop extends BaseIcon {}
IconArrowTop.defaultProps = {
    iconName: 'rec-icon-arrow-top',
    iconClass: 'rec-icon-arrow-top',
    alt: 'Up'
};

export class IconArrowBottom extends BaseIcon {}
IconArrowBottom.defaultProps = {
    iconName: 'rec-icon-arrow-bottom',
    iconClass: 'rec-icon-arrow-bottom',
    alt: 'Down'
};

export class IconCheck extends BaseIcon {}
IconCheck.defaultProps = {
    iconName: 'rec-icon-check',
    iconClass: 'rec-icon-check',
    alt: 'Check'
};

export class IconMoreHoriz extends BaseIcon {}
IconMoreHoriz.defaultProps = {
    iconName: 'rec-icon-more-horiz',
    iconClass: 'rec-icon-more-horiz',
    alt: 'More'
};

export class IconMoreVert extends BaseIcon {}
IconMoreVert.defaultProps = {
    iconName: 'rec-icon-more-vert',
    iconClass: 'rec-icon-more-vert',
    alt: 'More'
};

export class IconRefresh extends BaseIcon {}
IconRefresh.defaultProps = {
    iconName: 'rec-icon-refresh',
    iconClass: 'rec-icon-refresh',
    alt: 'Refresh'
};

export class IconTrendingFlat extends BaseIcon {}
IconTrendingFlat.defaultProps = {
    iconName: 'rec-icon-trending-flat',
    iconClass: 'rec-icon-trending-flat',
    alt: 'Flat Trending Arrow'
};

export class IconBackspace extends BaseIcon {}
IconBackspace.defaultProps = {
    iconName: 'rec-icon-backspace',
    iconClass: 'rec-icon-backspace',
    alt: 'Backspace'
};

export class IconFileDownload extends BaseIcon {}
IconFileDownload.defaultProps = {
    iconName: 'rec-icon-file-download',
    iconClass: 'rec-icon-file-download',
    alt: 'File Download'
};

export class IconFileUpload extends BaseIcon {}
IconFileUpload.defaultProps = {
    iconName: 'rec-icon-file-upload',
    iconClass: 'rec-icon-file-upload',
    alt: 'File Upload'
};

export class IconFilterList extends BaseIcon {}
IconFilterList.defaultProps = {
    iconName: 'rec-icon-filter-list',
    iconClass: 'rec-icon-filter-list',
    alt: 'Filter List'
};

export class IconFullscreenExit extends BaseIcon {}
IconFullscreenExit.defaultProps = {
    iconName: 'rec-icon-fullscreen-exit',
    iconClass: 'rec-icon-fullscreen-exit',
    alt: 'Fullscreen Exit'
};

export class IconFullscreen extends BaseIcon {}
IconFullscreen.defaultProps = {
    iconName: 'rec-icon-fullscreen',
    iconClass: 'rec-icon-fullscreen',
    alt: 'Fullscreen'
};

export class IconImportExport extends BaseIcon {}
IconImportExport.defaultProps = {
    iconName: 'rec-icon-import-export',
    iconClass: 'rec-icon-import-export',
    alt: 'Import Export'
};

export class IconKeyboardReturn extends BaseIcon {}
IconKeyboardReturn.defaultProps = {
    iconName: 'rec-icon-keyboard-return',
    iconClass: 'rec-icon-keyboard-return',
    alt: 'Keyboard Return'
};

export class IconKeyboardTab extends BaseIcon {}
IconKeyboardTab.defaultProps = {
    iconName: 'rec-icon-keyboard-tab',
    iconClass: 'rec-icon-keyboard-tab',
    alt: 'Keyboard Tab'
};

export class IconMenu extends BaseIcon {}
IconMenu.defaultProps = {
    iconName: 'rec-icon-menu',
    iconClass: 'rec-icon-menu',
    alt: 'Menu'
};

export class IconReply extends BaseIcon {}
IconReply.defaultProps = {
    iconName: 'rec-icon-reply',
    iconClass: 'rec-icon-reply',
    alt: 'Reply'
};

export class IconSwapHoriz extends BaseIcon {}
IconSwapHoriz.defaultProps = {
    iconName: 'rec-icon-swap-horiz',
    iconClass: 'rec-icon-swap-horiz',
    alt: 'Horizontal Swap'
};

export class IconApps extends BaseIcon {}
IconApps.defaultProps = {
    iconName: 'rec-icon-apps',
    iconClass: 'rec-icon-apps',
    alt: 'Apps'
};

export class IconCached extends BaseIcon {}
IconCached.defaultProps = {
    iconName: 'rec-icon-cached',
    iconClass: 'rec-icon-cached',
    alt: 'Cached Item'
};

export class IconDelete extends BaseIcon {}
IconDelete.defaultProps = {
    iconName: 'rec-icon-delete',
    iconClass: 'rec-icon-delete',
    alt: 'Delete'
};

export class IconExitToApp extends BaseIcon {}
IconExitToApp.defaultProps = {
    iconName: 'rec-icon-exit-to-app',
    iconClass: 'rec-icon-exit-to-app',
    alt: 'Exit to App'
};

export class IconHistory extends BaseIcon {}
IconHistory.defaultProps = {
    iconName: 'rec-icon-history',
    iconClass: 'rec-icon-history',
    alt: 'History'
};

export class IconInput extends BaseIcon {}
IconInput.defaultProps = {
    iconName: 'rec-icon-input',
    iconClass: 'rec-icon-input',
    alt: 'Input'
};

export class IconLaunch extends BaseIcon {}
IconLaunch.defaultProps = {
    iconName: 'rec-icon-launch',
    iconClass: 'rec-icon-launch',
    alt: 'Launch'
};

export class IconLockOpen extends BaseIcon {}
IconLockOpen.defaultProps = {
    iconName: 'rec-icon-lock-open',
    iconClass: 'rec-icon-lock-open',
    alt: 'Open Lock'
};

export class IconLockOutline extends BaseIcon {}
IconLockOutline.defaultProps = {
    iconName: 'rec-icon-lock-outline',
    iconClass: 'rec-icon-lock-outline',
    alt: 'Lock'
};

export class IconLock extends BaseIcon {}
IconLock.defaultProps = {
    iconName: 'rec-icon-lock',
    iconClass: 'rec-icon-lock',
    alt: 'Lock'
};

export class IconLoop extends BaseIcon {}
IconLoop.defaultProps = {
    iconName: 'rec-icon-loop',
    iconClass: 'rec-icon-loop',
    alt: 'Loop'
};

export class IconOpenInBrowser extends BaseIcon {}
IconOpenInBrowser.defaultProps = {
    iconName: 'rec-icon-open-in-browser',
    iconClass: 'rec-icon-open-in-browser',
    alt: 'Open in Browser'
};

export class IconOpenWith extends BaseIcon {}
IconOpenWith.defaultProps = {
    iconName: 'rec-icon-open-with',
    iconClass: 'rec-icon-open-with',
    alt: 'Open With'
};

export class IconPageview extends BaseIcon {}
IconPageview.defaultProps = {
    iconName: 'rec-icon-pageview',
    iconClass: 'rec-icon-pageview',
    alt: 'Pageview'
};

export class IconRemoveCircleOutline extends BaseIcon {}
IconRemoveCircleOutline.defaultProps = {
    iconName: 'rec-icon-remove-circle-outline',
    iconClass: 'rec-icon-remove-circle-outline',
    alt: 'Remove'
};

export class IconRemoveCircle extends BaseIcon {}
IconRemoveCircle.defaultProps = {
    iconName: 'rec-icon-remove-circle',
    iconClass: 'rec-icon-remove-circle',
    alt: 'Remove'
};

export class IconRemove extends BaseIcon {}
IconRemove.defaultProps = {
    iconName: 'rec-icon-remove',
    iconClass: 'rec-icon-remove',
    alt: 'Remove'
};

export class IconReplay extends BaseIcon {}
IconReplay.defaultProps = {
    iconName: 'rec-icon-replay',
    iconClass: 'rec-icon-replay',
    alt: 'Replay'
};

export class IconShare extends BaseIcon {}
IconShare.defaultProps = {
    iconName: 'rec-icon-share',
    iconClass: 'rec-icon-share',
    alt: 'Share'
};

export class IconBookmarkBorder extends BaseIcon {}
IconBookmarkBorder.defaultProps = {
    iconName: 'rec-icon-bookmark-border',
    iconClass: 'rec-icon-bookmark-border',
    alt: 'Bookmark'
};

export class IconBookmark extends BaseIcon {}
IconBookmark.defaultProps = {
    iconName: 'rec-icon-bookmark',
    iconClass: 'rec-icon-bookmark',
    alt: 'Bookmark'
};

export class IconFavoriteBorder extends BaseIcon {}
IconFavoriteBorder.defaultProps = {
    iconName: 'rec-icon-favorite-border',
    iconClass: 'rec-icon-favorite-border',
    alt: 'Bordered Favorite'
};

export class IconFavorite extends BaseIcon {}
IconFavorite.defaultProps = {
    iconName: 'rec-icon-favorite',
    iconClass: 'rec-icon-favorite',
    alt: 'Favorite'
};

export class IconHelp extends BaseIcon {}
IconHelp.defaultProps = {
    iconName: 'rec-icon-help',
    iconClass: 'rec-icon-help',
    alt: 'Help'
};

export class IconHelpOutline extends BaseIcon {}
IconHelpOutline.defaultProps = {
    iconName: 'rec-icon-help-outline',
    iconClass: 'rec-icon-help-outline',
    alt: 'An Icon Depicting Help'
};

export class IconInfoOutline extends BaseIcon {}
IconInfoOutline.defaultProps = {
    iconName: 'rec-icon-info-outline',
    iconClass: 'rec-icon-info-outline',
    alt: 'Information'
};

export class IconLabelOutline extends BaseIcon {}
IconLabelOutline.defaultProps = {
    iconName: 'rec-icon-label-outline',
    iconClass: 'rec-icon-label-outline',
    alt: 'Label'
};

export class IconLabel extends BaseIcon {}
IconLabel.defaultProps = {
    iconName: 'rec-icon-label',
    iconClass: 'rec-icon-label',
    alt: 'Label'
};

export class IconGlobe extends BaseIcon {}
IconGlobe.defaultProps = {
    iconName: 'rec-icon-globe',
    iconClass: 'rec-icon-globe',
    alt: 'Globe'
};

export class IconNewReleases extends BaseIcon {}
IconNewReleases.defaultProps = {
    iconName: 'rec-icon-new-releases',
    iconClass: 'rec-icon-new-releases',
    alt: 'New Releases'
};

export class IconReport extends BaseIcon {}
IconReport.defaultProps = {
    iconName: 'rec-icon-report',
    iconClass: 'rec-icon-report',
    alt: 'Report'
};

export class IconStarBorder extends BaseIcon {}
IconStarBorder.defaultProps = {
    iconName: 'rec-icon-star-border',
    iconClass: 'rec-icon-star-border',
    alt: 'Bordered Star'
};

export class IconStarHalf extends BaseIcon {}
IconStarHalf.defaultProps = {
    iconName: 'rec-icon-star-half',
    iconClass: 'rec-icon-star-half',
    alt: 'Half a Star'
};

export class IconStar extends BaseIcon {}
IconStar.defaultProps = {
    iconName: 'rec-icon-star',
    iconClass: 'rec-icon-star',
    alt: 'Star'
};

export class IconThumbDown extends BaseIcon {}
IconThumbDown.defaultProps = {
    iconName: 'rec-icon-thumb-down',
    iconClass: 'rec-icon-thumb-down',
    alt: 'Thumb Down'
};

export class IconThumbUp extends BaseIcon {}
IconThumbUp.defaultProps = {
    iconName: 'rec-icon-thumb-up',
    iconClass: 'rec-icon-thumb-up',
    alt: 'Thumb Up'
};

export class IconThumbsUpDown extends BaseIcon {}
IconThumbsUpDown.defaultProps = {
    iconName: 'rec-icon-thumbs-up-down',
    iconClass: 'rec-icon-thumbs-up-down',
    alt: 'Thumbs Up and Down'
};

export class IconDashboard extends BaseIcon {}
IconDashboard.defaultProps = {
    iconName: 'rec-icon-dashboard',
    iconClass: 'rec-icon-dashboard',
    alt: 'Dashboard'
};

export class IconFlag extends BaseIcon {}
IconFlag.defaultProps = {
    iconName: 'rec-icon-flag',
    iconClass: 'rec-icon-flag',
    alt: 'Flag'
};

export class IconList extends BaseIcon {}
IconList.defaultProps = {
    iconName: 'rec-icon-list',
    iconClass: 'rec-icon-list',
    alt: 'List'
};

export class IconMap extends BaseIcon {}
IconMap.defaultProps = {
    iconName: 'rec-icon-map',
    iconClass: 'rec-icon-map',
    alt: 'Map'
};

export class IconMyLocation extends BaseIcon {}
IconMyLocation.defaultProps = {
    iconName: 'rec-icon-my-location',
    iconClass: 'rec-icon-my-location',
    alt: 'My Location'
};

export class IconNavigation extends BaseIcon {}
IconNavigation.defaultProps = {
    iconName: 'rec-icon-navigation',
    iconClass: 'rec-icon-navigation',
    alt: 'Navigation'
};

export class IconPinDrop extends BaseIcon {}
IconPinDrop.defaultProps = {
    iconName: 'rec-icon-pin-drop',
    iconClass: 'rec-icon-pin-drop',
    alt: 'Pin Drop'
};

export class IconPin extends BaseIcon {}
IconPin.defaultProps = {
    iconName: 'rec-icon-pin',
    iconClass: 'rec-icon-pin',
    alt: 'Pin'
};

export class IconVerifiedUser extends BaseIcon {}
IconVerifiedUser.defaultProps = {
    iconName: 'rec-icon-verified-user',
    iconClass: 'rec-icon-verified-user',
    alt: 'Verified User'
};

export class IconViewAgenda extends BaseIcon {}
IconViewAgenda.defaultProps = {
    iconName: 'rec-icon-view-agenda',
    iconClass: 'rec-icon-view-agenda',
    alt: 'Agenda View'
};

export class IconViewArray extends BaseIcon {}
IconViewArray.defaultProps = {
    iconName: 'rec-icon-view-array',
    iconClass: 'rec-icon-view-array',
    alt: 'Array View'
};

export class IconViewColumn extends BaseIcon {}
IconViewColumn.defaultProps = {
    iconName: 'rec-icon-view-column',
    iconClass: 'rec-icon-view-column',
    alt: 'Column View'
};

export class IconViewHeadline extends BaseIcon {}
IconViewHeadline.defaultProps = {
    iconName: 'rec-icon-view-headline',
    iconClass: 'rec-icon-view-headline',
    alt: 'Headline View'
};

export class IconViewList extends BaseIcon {}
IconViewList.defaultProps = {
    iconName: 'rec-icon-view-list',
    iconClass: 'rec-icon-view-list',
    alt: 'List View'
};

export class IconViewModule extends BaseIcon {}
IconViewModule.defaultProps = {
    iconName: 'rec-icon-view-module',
    iconClass: 'rec-icon-view-module',
    alt: 'Module View'
};

export class IconViewQuilt extends BaseIcon {}
IconViewQuilt.defaultProps = {
    iconName: 'rec-icon-view-quilt',
    iconClass: 'rec-icon-view-quilt',
    alt: 'Quilt View'
};

export class IconViewStream extends BaseIcon {}
IconViewStream.defaultProps = {
    iconName: 'rec-icon-view-stream',
    iconClass: 'rec-icon-view-stream',
    alt: 'Stream View'
};

export class IconViewWeek extends BaseIcon {}
IconViewWeek.defaultProps = {
    iconName: 'rec-icon-view-week',
    iconClass: 'rec-icon-view-week',
    alt: 'Week View'
};

export class IconFastForward extends BaseIcon {}
IconFastForward.defaultProps = {
    iconName: 'rec-icon-fast-forward',
    iconClass: 'rec-icon-fast-forward',
    alt: 'Fast Forward'
};

export class IconMicNone extends BaseIcon {}
IconMicNone.defaultProps = {
    iconName: 'rec-icon-mic-none',
    iconClass: 'rec-icon-mic-none',
    alt: 'No Mic'
};

export class IconMicOff extends BaseIcon {}
IconMicOff.defaultProps = {
    iconName: 'rec-icon-mic-off',
    iconClass: 'rec-icon-mic-off',
    alt: 'Mic Off'
};

export class IconMic extends BaseIcon {}
IconMic.defaultProps = {
    iconName: 'rec-icon-mic',
    iconClass: 'rec-icon-mic',
    alt: 'Mic'
};

export class IconPauseCircleOutline extends BaseIcon {}
IconPauseCircleOutline.defaultProps = {
    iconName: 'rec-icon-pause-circle-outline',
    iconClass: 'rec-icon-pause-circle-outline',
    alt: 'Pause'
};

export class IconPauseCircle extends BaseIcon {}
IconPauseCircle.defaultProps = {
    iconName: 'rec-icon-pause-circle',
    iconClass: 'rec-icon-pause-circle',
    alt: 'Pause'
};

export class IconPause extends BaseIcon {}
IconPause.defaultProps = {
    iconName: 'rec-icon-pause',
    iconClass: 'rec-icon-pause',
    alt: 'Pause'
};

export class IconPlayArrow extends BaseIcon {}
IconPlayArrow.defaultProps = {
    iconName: 'rec-icon-play-arrow',
    iconClass: 'rec-icon-play-arrow',
    alt: 'Play Arrow'
};

export class IconPlayCircleOutline extends BaseIcon {}
IconPlayCircleOutline.defaultProps = {
    iconName: 'rec-icon-play-circle-outline',
    iconClass: 'rec-icon-play-circle-outline',
    alt: 'Play'
};

export class IconPlayCircle extends BaseIcon {}
IconPlayCircle.defaultProps = {
    iconName: 'rec-icon-play-circle',
    iconClass: 'rec-icon-play-circle',
    alt: 'Play'
};

export class IconSkipNext extends BaseIcon {}
IconSkipNext.defaultProps = {
    iconName: 'rec-icon-skip-next',
    iconClass: 'rec-icon-skip-next',
    alt: 'Skip to Next'
};

export class IconVisibilityOff extends BaseIcon {}
IconVisibilityOff.defaultProps = {
    iconName: 'rec-icon-visibility-off',
    iconClass: 'rec-icon-visibility-off',
    alt: 'Visibility Off'
};

export class IconVisibility extends BaseIcon {}
IconVisibility.defaultProps = {
    iconName: 'rec-icon-visibility',
    iconClass: 'rec-icon-visibility',
    alt: 'Visibility'
};

export class IconVolumeDown extends BaseIcon {}
IconVolumeDown.defaultProps = {
    iconName: 'rec-icon-volume-down',
    iconClass: 'rec-icon-volume-down',
    alt: 'Volume Down'
};

export class IconVolumeMute extends BaseIcon {}
IconVolumeMute.defaultProps = {
    iconName: 'rec-icon-volume-mute',
    iconClass: 'rec-icon-volume-mute',
    alt: 'Volume Mute'
};

export class IconVolumeOff extends BaseIcon {}
IconVolumeOff.defaultProps = {
    iconName: 'rec-icon-volume-off',
    iconClass: 'rec-icon-volume-off',
    alt: 'Volume Off'
};

export class IconVolumeUp extends BaseIcon {}
IconVolumeUp.defaultProps = {
    iconName: 'rec-icon-volume-up',
    iconClass: 'rec-icon-volume-up',
    alt: 'Volume Up'
};

export class IconWork extends BaseIcon {}
IconWork.defaultProps = {
    iconName: 'rec-icon-work',
    iconClass: 'rec-icon-work',
    alt: 'Work'
};

export class IconCardTravel extends BaseIcon {}
IconCardTravel.defaultProps = {
    iconName: 'rec-icon-card-travel',
    iconClass: 'rec-icon-card-travel',
    alt: 'Travel Card'
};

export class IconCartAdd extends BaseIcon {}
IconCartAdd.defaultProps = {
    iconName: 'rec-icon-cart-add',
    iconClass: 'rec-icon-cart-add',
    alt: 'Adding to Cart'
};

export class IconDesktopMac extends BaseIcon {}
IconDesktopMac.defaultProps = {
    iconName: 'rec-icon-desktop-mac',
    iconClass: 'rec-icon-desktop-mac',
    alt: 'Mac Desktop'
};

export class IconDesktopWindows extends BaseIcon {}
IconDesktopWindows.defaultProps = {
    iconName: 'rec-icon-desktop-windows',
    iconClass: 'rec-icon-desktop-windows',
    alt: 'Windows Desktop'
};

export class IconHearing extends BaseIcon {}
IconHearing.defaultProps = {
    iconName: 'rec-icon-hearing',
    iconClass: 'rec-icon-hearing',
    alt: 'Hearing'
};

export class IconKeyboard extends BaseIcon {}
IconKeyboard.defaultProps = {
    iconName: 'rec-icon-keyboard',
    iconClass: 'rec-icon-keyboard',
    alt: 'Keyboard'
};

export class IconLaptop extends BaseIcon {}
IconLaptop.defaultProps = {
    iconName: 'rec-icon-laptop',
    iconClass: 'rec-icon-laptop',
    alt: 'Laptop'
};

export class IconPayment extends BaseIcon {}
IconPayment.defaultProps = {
    iconName: 'rec-icon-payment',
    iconClass: 'rec-icon-payment',
    alt: 'Payment'
};

export class IconPhoneAndroid extends BaseIcon {}
IconPhoneAndroid.defaultProps = {
    iconName: 'rec-icon-phone-android',
    iconClass: 'rec-icon-phone-android',
    alt: 'Android Phone'
};

export class IconPhoneIphone extends BaseIcon {}
IconPhoneIphone.defaultProps = {
    iconName: 'rec-icon-phone-iphone',
    iconClass: 'rec-icon-phone-iphone',
    alt: 'iPhone'
};

export class IconSmartphoneLandscape extends BaseIcon {}
IconSmartphoneLandscape.defaultProps = {
    iconName: 'rec-icon-smartphone-landscape',
    iconClass: 'rec-icon-smartphone-landscape',
    alt: 'Smartphone on Landscape'
};

export class IconSmartphone extends BaseIcon {}
IconSmartphone.defaultProps = {
    iconName: 'rec-icon-smartphone',
    iconClass: 'rec-icon-smartphone',
    alt: 'Smartphone'
};

export class IconStore extends BaseIcon {}
IconStore.defaultProps = {
    iconName: 'rec-icon-store',
    iconClass: 'rec-icon-store',
    alt: 'Store'
};

export class IconTabletAndroid extends BaseIcon {}
IconTabletAndroid.defaultProps = {
    iconName: 'rec-icon-tablet-android',
    iconClass: 'rec-icon-tablet-android',
    alt: 'Android Tablet'
};

export class IconTabletLandscape extends BaseIcon {}
IconTabletLandscape.defaultProps = {
    iconName: 'rec-icon-tablet-landscape',
    iconClass: 'rec-icon-tablet-landscape',
    alt: 'Tablet on Landscape'
};

export class IconTabletMac extends BaseIcon {}
IconTabletMac.defaultProps = {
    iconName: 'rec-icon-tablet-mac',
    iconClass: 'rec-icon-tablet-mac',
    alt: 'Mac Tablet'
};

export class IconTv extends BaseIcon {}
IconTv.defaultProps = {
    iconName: 'rec-icon-tv',
    iconClass: 'rec-icon-tv',
    alt: 'TV'
};

export class IconVideocamOff extends BaseIcon {}
IconVideocamOff.defaultProps = {
    iconName: 'rec-icon-videocam-off',
    iconClass: 'rec-icon-videocam-off',
    alt: 'Off Videocam'
};

export class IconVideocam extends BaseIcon {}
IconVideocam.defaultProps = {
    iconName: 'rec-icon-videocam',
    iconClass: 'rec-icon-videocam',
    alt: 'Videocam'
};

export class IconAnnouncement extends BaseIcon {}
IconAnnouncement.defaultProps = {
    iconName: 'rec-icon-announcement',
    iconClass: 'rec-icon-announcement',
    alt: 'Announcement'
};

export class IconAttachment extends BaseIcon {}
IconAttachment.defaultProps = {
    iconName: 'rec-icon-attachment',
    iconClass: 'rec-icon-attachment',
    alt: 'Attachment'
};

export class IconCamera extends BaseIcon {}
IconCamera.defaultProps = {
    iconName: 'rec-icon-camera',
    iconClass: 'rec-icon-camera',
    alt: 'Camera'
};

export class IconChatBubble extends BaseIcon {}
IconChatBubble.defaultProps = {
    iconName: 'rec-icon-chat-bubble',
    iconClass: 'rec-icon-chat-bubble',
    alt: 'Chat Bubble'
};

export class IconChat extends BaseIcon {}
IconChat.defaultProps = {
    iconName: 'rec-icon-chat',
    iconClass: 'rec-icon-chat',
    alt: 'Chat'
};

export class IconClipboard extends BaseIcon {}
IconClipboard.defaultProps = {
    iconName: 'rec-icon-clipboard',
    iconClass: 'rec-icon-clipboard',
    alt: 'Clipboard'
};

export class IconComment extends BaseIcon {}
IconComment.defaultProps = {
    iconName: 'rec-icon-comment',
    iconClass: 'rec-icon-comment',
    alt: 'Comment'
};

export class IconCut extends BaseIcon {}
IconCut.defaultProps = {
    iconName: 'rec-icon-cut',
    iconClass: 'rec-icon-cut',
    alt: 'Scissors'
};

export class IconEdit extends BaseIcon {}
IconEdit.defaultProps = {
    iconName: 'rec-icon-edit',
    iconClass: 'rec-icon-edit',
    alt: 'Pencil'
};

export class IconExplore extends BaseIcon {}
IconExplore.defaultProps = {
    iconName: 'rec-icon-explore',
    iconClass: 'rec-icon-explore',
    alt: 'Explore'
};

export class IconForum extends BaseIcon {}
IconForum.defaultProps = {
    iconName: 'rec-icon-forum',
    iconClass: 'rec-icon-forum',
    alt: 'Forum'
};

export class IconLink extends BaseIcon {}
IconLink.defaultProps = {
    iconName: 'rec-icon-link',
    iconClass: 'rec-icon-link',
    alt: 'Link'
};

export class IconMouse extends BaseIcon {}
IconMouse.defaultProps = {
    iconName: 'rec-icon-mouse',
    iconClass: 'rec-icon-mouse',
    alt: 'Mouse'
};

export class IconPhone extends BaseIcon {}
IconPhone.defaultProps = {
    iconName: 'rec-icon-phone',
    iconClass: 'rec-icon-phone',
    alt: 'Phone'
};

export class IconPhoto extends BaseIcon {}
IconPhoto.defaultProps = {
    iconName: 'rec-icon-photo',
    iconClass: 'rec-icon-photo',
    alt: 'Photo'
};

export class IconPhotoUnavailable extends BaseIcon {}
IconPhotoUnavailable.defaultProps = {
    iconName: 'rec-icon-photo-unavailable',
    iconClass: 'rec-icon-photo-unavailable',
    alt: 'Missing Photo'
};

export class IconPrint extends BaseIcon {}
IconPrint.defaultProps = {
    iconName: 'rec-icon-print',
    iconClass: 'rec-icon-print',
    alt: 'Print'
};

export class IconSave extends BaseIcon {}
IconSave.defaultProps = {
    iconName: 'rec-icon-save',
    iconClass: 'rec-icon-save',
    alt: 'Floppy Disk'
};

export class IconTextsms extends BaseIcon {}
IconTextsms.defaultProps = {
    iconName: 'rec-icon-textsms',
    iconClass: 'rec-icon-textsms',
    alt: 'SMS Text'
};

export class IconAtm extends BaseIcon {}
IconAtm.defaultProps = {
    iconName: 'rec-icon-atm',
    iconClass: 'rec-icon-atm',
    alt: 'ATM'
};

export class IconAttraction extends BaseIcon {}
IconAttraction.defaultProps = {
    iconName: 'rec-icon-attraction',
    iconClass: 'rec-icon-attraction',
    alt: 'Attraction'
};

export class IconBar extends BaseIcon {}
IconBar.defaultProps = {
    iconName: 'rec-icon-bar',
    iconClass: 'rec-icon-bar',
    alt: 'Bar'
};

export class IconBike extends BaseIcon {}
IconBike.defaultProps = {
    iconName: 'rec-icon-bike',
    iconClass: 'rec-icon-bike',
    alt: 'Bike'
};

export class IconBoat extends BaseIcon {}
IconBoat.defaultProps = {
    iconName: 'rec-icon-boat',
    iconClass: 'rec-icon-boat',
    alt: 'Boat'
};

export class IconCafe extends BaseIcon {}
IconCafe.defaultProps = {
    iconName: 'rec-icon-cafe',
    iconClass: 'rec-icon-cafe',
    alt: 'Cafe'
};

export class IconCloudDone extends BaseIcon {}
IconCloudDone.defaultProps = {
    iconName: 'rec-icon-cloud-done',
    iconClass: 'rec-icon-cloud-done',
    alt: 'Cloud Done'
};

export class IconCloudDownload extends BaseIcon {}
IconCloudDownload.defaultProps = {
    iconName: 'rec-icon-cloud-download',
    iconClass: 'rec-icon-cloud-download',
    alt: 'Cloud Download'
};

export class IconCloudOff extends BaseIcon {}
IconCloudOff.defaultProps = {
    iconName: 'rec-icon-cloud-off',
    iconClass: 'rec-icon-cloud-off',
    alt: 'Cloud Off'
};

export class IconCloudQueue extends BaseIcon {}
IconCloudQueue.defaultProps = {
    iconName: 'rec-icon-cloud-queue',
    iconClass: 'rec-icon-cloud-queue',
    alt: 'Cloud Queue'
};

export class IconCloudUpload extends BaseIcon {}
IconCloudUpload.defaultProps = {
    iconName: 'rec-icon-cloud-upload',
    iconClass: 'rec-icon-cloud-upload',
    alt: 'Cloud Upload'
};

export class IconConvenienceStore extends BaseIcon {}
IconConvenienceStore.defaultProps = {
    iconName: 'rec-icon-convenience-store',
    iconClass: 'rec-icon-convenience-store',
    alt: 'Convenience Store'
};

export class IconDescription extends BaseIcon {}
IconDescription.defaultProps = {
    iconName: 'rec-icon-description',
    iconClass: 'rec-icon-description',
    alt: 'Description'
};

export class IconDining extends BaseIcon {}
IconDining.defaultProps = {
    iconName: 'rec-icon-dining',
    iconClass: 'rec-icon-dining',
    alt: 'Dining'
};

export class IconDirections extends BaseIcon {}
IconDirections.defaultProps = {
    iconName: 'rec-icon-directions',
    iconClass: 'rec-icon-directions',
    alt: 'Directions'
};

export class IconEmail extends BaseIcon {}
IconEmail.defaultProps = {
    iconName: 'rec-icon-email',
    iconClass: 'rec-icon-email',
    alt: 'Email'
};

export class IconEmailOutline extends BaseIcon {}
IconEmailOutline.defaultProps = {
    iconName: 'rec-icon-email-outline',
    iconClass: 'rec-icon-email-outline',
    alt: 'Email'
};

export class IconFlight extends BaseIcon {}
IconFlight.defaultProps = {
    iconName: 'rec-icon-flight',
    iconClass: 'rec-icon-flight',
    alt: 'Flight'
};

export class IconFolderOpen extends BaseIcon {}
IconFolderOpen.defaultProps = {
    iconName: 'rec-icon-folder-open',
    iconClass: 'rec-icon-folder-open',
    alt: 'Open Folder'
};

export class IconFolder extends BaseIcon {}
IconFolder.defaultProps = {
    iconName: 'rec-icon-folder',
    iconClass: 'rec-icon-folder',
    alt: 'Folder'
};

export class IconGasStation extends BaseIcon {}
IconGasStation.defaultProps = {
    iconName: 'rec-icon-gas-station',
    iconClass: 'rec-icon-gas-station',
    alt: 'Gas Station'
};

export class IconHospital extends BaseIcon {}
IconHospital.defaultProps = {
    iconName: 'rec-icon-hospital',
    iconClass: 'rec-icon-hospital',
    alt: 'Hospital'
};

export class IconHotel extends BaseIcon {}
IconHotel.defaultProps = {
    iconName: 'rec-icon-hotel',
    iconClass: 'rec-icon-hotel',
    alt: 'Hotel'
};

export class IconMailOpen extends BaseIcon {}
IconMailOpen.defaultProps = {
    iconName: 'rec-icon-mail-open',
    iconClass: 'rec-icon-mail-open',
    alt: 'Mail Open'
};

export class IconMoveToInbox extends BaseIcon {}
IconMoveToInbox.defaultProps = {
    iconName: 'rec-icon-move-to-inbox',
    iconClass: 'rec-icon-move-to-inbox',
    alt: 'Move to Inbox'
};

export class IconNoteAdd extends BaseIcon {}
IconNoteAdd.defaultProps = {
    iconName: 'rec-icon-note-add',
    iconClass: 'rec-icon-note-add',
    alt: 'Add a Note'
};

export class IconParking extends BaseIcon {}
IconParking.defaultProps = {
    iconName: 'rec-icon-parking',
    iconClass: 'rec-icon-parking',
    alt: 'Parking'
};

export class IconPizza extends BaseIcon {}
IconPizza.defaultProps = {
    iconName: 'rec-icon-pizza',
    iconClass: 'rec-icon-pizza',
    alt: 'Pizza'
};

export class IconShipping extends BaseIcon {}
IconShipping.defaultProps = {
    iconName: 'rec-icon-shipping',
    iconClass: 'rec-icon-shipping',
    alt: 'Shipping'
};

export class IconTaxi extends BaseIcon {}
IconTaxi.defaultProps = {
    iconName: 'rec-icon-taxi',
    iconClass: 'rec-icon-taxi',
    alt: 'Taxi'
};

export class IconTrain extends BaseIcon {}
IconTrain.defaultProps = {
    iconName: 'rec-icon-train',
    iconClass: 'rec-icon-train',
    alt: 'Train'
};

export class IconTransit extends BaseIcon {}
IconTransit.defaultProps = {
    iconName: 'rec-icon-transit',
    iconClass: 'rec-icon-transit',
    alt: 'Transit'
};

export class IconWalk extends BaseIcon {}
IconWalk.defaultProps = {
    iconName: 'rec-icon-walk',
    iconClass: 'rec-icon-walk',
    alt: 'Walk'
};

export class IconBus extends BaseIcon {}
IconBus.defaultProps = {
    iconName: 'rec-icon-bus',
    iconClass: 'rec-icon-bus',
    alt: 'Bus'
};

export class IconCloseCircleOutline extends BaseIcon {}
IconCloseCircleOutline.defaultProps = {
    iconName: 'rec-icon-close-circle-outline',
    iconClass: 'rec-icon-close-circle-outline',
    alt: 'Outline Close Circle'
};

export class IconCloudCircle extends BaseIcon {}
IconCloudCircle.defaultProps = {
    iconName: 'rec-icon-cloud-circle',
    iconClass: 'rec-icon-cloud-circle',
    alt: 'Cloud Circle'
};

export class IconCloud extends BaseIcon {}
IconCloud.defaultProps = {
    iconName: 'rec-icon-cloud',
    iconClass: 'rec-icon-cloud',
    alt: 'Cloud'
};

export class IconCar extends BaseIcon {}
IconCar.defaultProps = {
    iconName: 'rec-icon-car',
    iconClass: 'rec-icon-car',
    alt: 'Car'
};

export class IconFastRewind extends BaseIcon {}
IconFastRewind.defaultProps = {
    iconName: 'rec-icon-fast-rewind',
    iconClass: 'rec-icon-fast-rewind',
    alt: 'Fast Rewind'
};

export class IconHeadsetMic extends BaseIcon {}
IconHeadsetMic.defaultProps = {
    iconName: 'rec-icon-headset-mic',
    iconClass: 'rec-icon-headset-mic',
    alt: 'Headset Mic'
};

export class IconHeadset extends BaseIcon {}
IconHeadset.defaultProps = {
    iconName: 'rec-icon-headset',
    iconClass: 'rec-icon-headset',
    alt: 'Headset'
};

export class IconMall extends BaseIcon {}
IconMall.defaultProps = {
    iconName: 'rec-icon-mall',
    iconClass: 'rec-icon-mall',
    alt: 'Mall'
};

export class IconOffer extends BaseIcon {}
IconOffer.defaultProps = {
    iconName: 'rec-icon-offer',
    iconClass: 'rec-icon-offer',
    alt: 'Offer'
};

export class IconSend extends BaseIcon {}
IconSend.defaultProps = {
    iconName: 'rec-icon-send',
    iconClass: 'rec-icon-send',
    alt: 'Send'
};

export class IconSkipPrevious extends BaseIcon {}
IconSkipPrevious.defaultProps = {
    iconName: 'rec-icon-skip-previous',
    iconClass: 'rec-icon-skip-previous',
    alt: 'Skip Previous'
};

export class IconTerrain extends BaseIcon {}
IconTerrain.defaultProps = {
    iconName: 'rec-icon-terrain',
    iconClass: 'rec-icon-terrain',
    alt: 'Terrain'
};

export class IconArrowLeft extends BaseIcon {}
IconArrowLeft.defaultProps = {
    iconName: 'rec-icon-arrow-left',
    iconClass: 'rec-icon-arrow-left',
    alt: 'Left'
};

export class IconArrowRight extends BaseIcon {}
IconArrowRight.defaultProps = {
    iconName: 'rec-icon-arrow-right',
    iconClass: 'rec-icon-arrow-right',
    alt: 'Right'
};

export class IconBlock extends BaseIcon {}
IconBlock.defaultProps = {
    iconName: 'rec-icon-block',
    iconClass: 'rec-icon-block',
    alt: 'Block'
};

export class IconUnfoldLess extends BaseIcon {}
IconUnfoldLess.defaultProps = {
    iconName: 'rec-icon-unfold-less',
    iconClass: 'rec-icon-unfold-less',
    alt: 'Unfold Less'
};

export class IconUnfoldMore extends BaseIcon {}
IconUnfoldMore.defaultProps = {
    iconName: 'rec-icon-unfold-more',
    iconClass: 'rec-icon-unfold-more',
    alt: 'Unfold More'
};

export class IconCheckCircleOutline extends BaseIcon {}
IconCheckCircleOutline.defaultProps = {
    iconName: 'rec-icon-check-circle-outline',
    iconClass: 'rec-icon-check-circle-outline',
    alt: 'Check'
};

export class IconHourglassHalf extends BaseIcon {}
IconHourglassHalf.defaultProps = {
    iconName: 'rec-icon-hourglass-half',
    iconClass: 'rec-icon-hourglass-half',
    alt: 'Hourglass'
};

export class IconActivityWater extends BaseIcon {}
IconActivityWater.defaultProps = {
    iconName: 'rec-icon-activity-water',
    iconClass: 'rec-icon-activity-water',
    alt: 'Water'
};

export class IconBullet extends BaseIcon {}
IconBullet.defaultProps = {
    iconName: 'rec-icon-bullet',
    iconClass: 'rec-icon-bullet',
    alt: 'A Circle'
};

export class IconCard extends BaseIcon {}
IconCard.defaultProps = {
    iconName: 'rec-icon-card',
    iconClass: 'rec-icon-card',
    alt: 'Permit'
};

export class IconTent extends BaseIcon {}
IconTent.defaultProps = {
    iconName: 'rec-icon-tent',
    iconClass: 'rec-icon-tent',
    alt: 'Camping'
};

export class IconTicket extends BaseIcon {}
IconTicket.defaultProps = {
    iconName: 'rec-icon-ticket',
    iconClass: 'rec-icon-ticket',
    alt: 'Ticket'
};

export class IconSort extends BaseIcon {}
IconSort.defaultProps = {
    iconName: 'rec-icon-sort',
    iconClass: 'rec-icon-sort',
    alt: 'Up & Down Arrows'
};

export class IconAccessible extends BaseIcon {}
IconAccessible.defaultProps = {
    iconName: 'rec-icon-accessible',
    iconClass: 'rec-icon-accessible',
    alt: 'Accessible'
};

export class IconPicnicTable extends BaseIcon {}
IconPicnicTable.defaultProps = {
    iconName: 'rec-icon-picnic-table',
    iconClass: 'rec-icon-picnic-table',
    alt: 'Picnic Table'
};

export class IconCardOutline extends BaseIcon {}
IconCardOutline.defaultProps = {
    iconName: 'rec-icon-card-outline',
    iconClass: 'rec-icon-card-outline',
    alt: 'Permit'
};

export class IconPet extends BaseIcon {}
IconPet.defaultProps = {
    iconName: 'rec-icon-pet',
    iconClass: 'rec-icon-pet',
    alt: 'Paw'
};

export class IconElectricity05 extends BaseIcon {}
IconElectricity05.defaultProps = {
    iconName: 'rec-icon-electricity-05',
    iconClass: 'rec-icon-electricity-05',
    alt: '5 Amp Electric Hookup'
};

export class IconElectricity15 extends BaseIcon {}
IconElectricity15.defaultProps = {
    iconName: 'rec-icon-electricity-15',
    iconClass: 'rec-icon-electricity-15',
    alt: '15 Amp Electric Hookup'
};

export class IconElectricity20 extends BaseIcon {}
IconElectricity20.defaultProps = {
    iconName: 'rec-icon-electricity-20',
    iconClass: 'rec-icon-electricity-20',
    alt: '20 Amp Electric Hookup'
};

export class IconElectricity30 extends BaseIcon {}
IconElectricity30.defaultProps = {
    iconName: 'rec-icon-electricity-30',
    iconClass: 'rec-icon-electricity-30',
    alt: '30 Amp Electric Hookup'
};

export class IconElectricity50 extends BaseIcon {}
IconElectricity50.defaultProps = {
    iconName: 'rec-icon-electricity-50',
    iconClass: 'rec-icon-electricity-50',
    alt: '50 Amp Electric Hookup'
};

export class IconElectricity100 extends BaseIcon {}
IconElectricity100.defaultProps = {
    iconName: 'rec-icon-electricity-100',
    iconClass: 'rec-icon-electricity-100',
    alt: '100 Amp Electric Hookup'
};

export class IconTrailerHookup extends BaseIcon {}
IconTrailerHookup.defaultProps = {
    iconName: 'rec-icon-trailer-hookup',
    iconClass: 'rec-icon-trailer-hookup',
    alt: 'Trailer Hookup'
};

export class IconLottery extends BaseIcon {}
IconLottery.defaultProps = {
    iconName: 'rec-icon-lottery',
    iconClass: 'rec-icon-lottery',
    alt: 'Lottery'
};

export class IconTree extends BaseIcon {}
IconTree.defaultProps = {
    iconName: 'rec-icon-tree',
    iconClass: 'rec-icon-tree',
    alt: 'Tree'
};

export class IconCompass extends BaseIcon {}
IconCompass.defaultProps = {
    iconName: 'rec-icon-compass',
    iconClass: 'rec-icon-compass',
    alt: 'Compass'
};

export class IconChevronDownCircleOutline extends BaseIcon {}
IconChevronDownCircleOutline.defaultProps = {
    iconName: 'rec-icon-chevron-down-circle-outline',
    iconClass: 'rec-icon-chevron-down-circle-outline',
    alt: 'Down'
};

export class IconFacebook extends BaseIcon {}
IconFacebook.defaultProps = {
    iconName: 'rec-icon-facebook',
    iconClass: 'rec-icon-facebook',
    alt: 'Facebook'
};

export class IconInstagram extends BaseIcon {}
IconInstagram.defaultProps = {
    iconName: 'rec-icon-instagram',
    iconClass: 'rec-icon-instagram',
    alt: 'Instagram'
};

export class IconPinterest extends BaseIcon {}
IconPinterest.defaultProps = {
    iconName: 'rec-icon-pinterest',
    iconClass: 'rec-icon-pinterest',
    alt: 'Pinterest'
};

export class IconBoatSite extends BaseIcon {}
IconBoatSite.defaultProps = {
    iconName: 'rec-icon-boat-site',
    iconClass: 'rec-icon-boat-site',
    alt: 'Boat'
};

export class IconCabin extends BaseIcon {}
IconCabin.defaultProps = {
    iconName: 'rec-icon-cabin',
    iconClass: 'rec-icon-cabin',
    alt: 'Cabin'
};

export class IconSmallTent extends BaseIcon {}
IconSmallTent.defaultProps = {
    iconName: 'rec-icon-small-tent',
    iconClass: 'rec-icon-small-tent',
    alt: 'Small Tent'
};

export class IconHorseSite extends BaseIcon {}
IconHorseSite.defaultProps = {
    iconName: 'rec-icon-horse-site',
    iconClass: 'rec-icon-horse-site',
    alt: 'Horseshoe'
};

export class IconRvTrailer extends BaseIcon {}
IconRvTrailer.defaultProps = {
    iconName: 'rec-icon-rv-trailer',
    iconClass: 'rec-icon-rv-trailer',
    alt: 'Trailer'
};

export class IconYurt extends BaseIcon {}
IconYurt.defaultProps = {
    iconName: 'rec-icon-yurt',
    iconClass: 'rec-icon-yurt',
    alt: 'Yurt'
};

export class IconRental extends BaseIcon {}
IconRental.defaultProps = {
    iconName: 'rec-icon-rental',
    iconClass: 'rec-icon-rental',
    alt: 'Rental'
};

export class IconPermit extends BaseIcon {}
IconPermit.defaultProps = {
    iconName: 'rec-icon-permit',
    iconClass: 'rec-icon-permit',
    alt: 'Permit'
};

export class IconRecMenu extends BaseIcon {}
IconRecMenu.defaultProps = {
    iconName: 'rec-icon-rec-menu',
    iconClass: 'rec-icon-rec-menu',
    alt: 'Dropdown Menu'
};

export class IconRefund extends BaseIcon {}
IconRefund.defaultProps = {
    iconName: 'rec-icon-refund',
    iconClass: 'rec-icon-refund',
    alt: 'Refund'
};

export class IconQuote extends BaseIcon {}
IconQuote.defaultProps = {
    iconName: 'rec-icon-quote',
    iconClass: 'rec-icon-quote',
    alt: 'Quotation marks'
};

export class IconVehiclePermit extends BaseIcon {}
IconVehiclePermit.defaultProps = {
    iconName: 'rec-icon-vehicle-permit',
    iconClass: 'rec-icon-vehicle-permit',
    alt: 'Vehicle Permit'
};

export class IconWaterHookup extends BaseIcon {}
IconWaterHookup.defaultProps = {
    iconName: 'rec-icon-water-hookup',
    iconClass: 'rec-icon-water-hookup',
    alt: 'Water Hookup'
};
